export default __webpack_public_path__ + "static/media/api.f9480046.png";